import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { SubscribeAssetModalProps } from './ConfirmExchange.modal.web';

export enum ConfirmExchangeStackRoutes {
  ApplicationInstruction = 'Application Instruction'
}

export type ConfirmExchangeStackParamList = {
  [ConfirmExchangeStackRoutes.ApplicationInstruction]: SubscribeAssetModalProps;
};

export type ConfirmExchangeStackScreenProps<Screen extends keyof ConfirmExchangeStackParamList> = NativeStackScreenProps<
  ConfirmExchangeStackParamList,
  Screen
>;
